module.exports = __webpack_public_path__ + "img/pro_fourteen_9.846a7d64.jpg";